import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& img": {
      width: "80px",
      Height: "80px",
      borderRadius: "50%",
      margin: "15px",
      cursor: "pointer",
    },
  },
  imageWrapper: {
    position: "relative",
  },
  checkIcon: {
    position: "absolute",
    top: "0",
    left: "0",
    color: theme.palette.primary.main,
  },
}));

const images = [
  {
    name: "pi-set-1-0",
    address: "/images/profileImages/pi-set-1-0.png",
  },
  {
    name: "pi-set-1-1",
    address: "/images/profileImages/pi-set-1-1.png",
  },
  {
    name: "pi-set-1-2",
    address: "/images/profileImages/pi-set-1-2.png",
  },
  {
    name: "pi-set-1-3",
    address: "/images/profileImages/pi-set-1-3.png",
  },
  {
    name: "pi-set-1-4",
    address: "/images/profileImages/pi-set-1-4.png",
  },
  {
    name: "pi-set-1-5",
    address: "/images/profileImages/pi-set-1-5.png",
  },
  {
    name: "pi-set-1-6",
    address: "/images/profileImages/pi-set-1-6.png",
  },
  {
    name: "pi-set-1-7",
    address: "/images/profileImages/pi-set-1-7.png",
  },
  {
    name: "pi-set-1-8",
    address: "/images/profileImages/pi-set-1-8.png",
  },
  {
    name: "pi-set-1-9",
    address: "/images/profileImages/pi-set-1-9.png",
  },
];

export default function ChangeProfileDialog({
  open,
  handleClose,
  action,
  selected,
}) {
  const classes = useStyles();
  const [current, setCurrent] = useState("");
  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={"sm"}>
      <DialogContent>
        <DialogContentText>تعویض عکس پروفایل</DialogContentText>
        <Box className={classes.imageContainer}>
          {images.map((item, index) => {
            return (
              <Box className={classes.imageWrapper}>
                <img
                  src={item.address}
                  alt={item.name}
                  key={index}
                  onClick={() => setCurrent(item.name)}
                />
                {current === item.name && (
                  <CheckCircleIcon className={classes.checkIcon} />
                )}
              </Box>
            );
          })}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => action(current)} color="primary">
          تایید
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
